import usePageMeta from "@/hooks/usePageMeta";
import HomeHero from "@/pages/home/components/HomeHero";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import HotCarousel from "@/pages/home/components/HotCarousel";
import LatestList from "@/pages/home/components/LatestList";
import SiteIntro from "@/pages/home/components/SiteIntro";
import HotRanking from "@/pages/home/components/HotRanking";

export default function Home() {
  usePageMeta({
    title: "禁漫天堂-热门漫画下载平台",
    description:
      "禁漫天堂为用户提供丰富的漫画资源下载服务，涵盖多种漫画类型，满足漫画爱好者的下载需求。方便快捷，种类多样，尽享精彩漫画世界。",
    keywords: "禁漫天堂,漫画下载,漫画资源,热门漫画,免费漫画下载,漫画全集,漫画平台",
  });

  return (
    <div className="w-full">
      <HomeHero />
      <CategoryEntries />

      <div className="w-full px-4 pb-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-8">
          <div className="flex flex-col gap-8 lg:col-span-2 lg:gap-10">
            <HotCarousel />
            <LatestList />
          </div>
          <aside className="lg:col-span-1">
            <div className="lg:sticky lg:top-20">
              <HotRanking />
            </div>
          </aside>
        </div>
      </div>

      <div className="w-full px-4 py-8 md:px-6 md:py-10">
        <SiteIntro />
      </div>
    </div>
  );
}